module.exports = __webpack_public_path__ + "img/homepro1.8d308547.png";